import ability from './ability'
import customSidebarContent from '@/navigation/custom/sidebarContent'

// custom/sidebarContent.js からルート名 → custom:* permission マッピングを自動生成
const buildRoutePermissionMap = sidebarItems => {
  const map = {}
  const addItem = item => {
    if (item.to?.name && item.resource?.startsWith('custom:')) {
      map[item.to.name] = item.resource
    }
    if (item.children) {
      item.children.forEach(addItem)
    }
  }
  sidebarItems.forEach(addItem)

  return map
}

const ROUTE_TO_CUSTOM_PERMISSION = buildRoutePermissionMap(customSidebarContent)

// ルート名のプレフィックスマッチで親ルートのpermissionを探す
// 例: 'waiter-data-tables' → 'waiter-data' の permission を継承
const findCustomPermission = routeName => {
  if (ROUTE_TO_CUSTOM_PERMISSION[routeName]) {
    return ROUTE_TO_CUSTOM_PERMISSION[routeName]
  }

  // プレフィックスが最も長く一致するルートを探す
  let bestMatch = null
  let bestLength = 0
  Object.keys(ROUTE_TO_CUSTOM_PERMISSION).forEach(key => {
    if (routeName.startsWith(`${key}-`) && key.length > bestLength) {
      bestMatch = key
      bestLength = key.length
    }
  })

  return bestMatch ? ROUTE_TO_CUSTOM_PERMISSION[bestMatch] : null
}

const isCustomUser = () => {
  const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}')

  return currentUser.role === 'custom'
}

export const canNavigate = to => {
  // customユーザーの場合、対応するcustom:*権限をチェック
  if (isCustomUser()) {
    const customPermission = findCustomPermission(to.name)

    if (customPermission) {
      return ability.can('read', customPermission)
    }

    // マッピングにないルートはPublicか通常の権限チェック
  }

  // 通常のチェック（admin/waiter/publicルート）
  return to.matched.some(route => ability.can(route.meta.action || 'read', route.meta.resource))
}

export const _ = undefined
